<template>
    <div class="modal-fade" :class="{ 'is-active': active }">
        <div class="modal modal--simple is-active" :class="classes">
            <div class="modal-background" @click="handleCloseModal('background')" />
            <div class="modal-card">
                <header class="modal-card-head">
                    <a
                        v-if="hasDownload"
                        class="modal-card-head__icon"
                        download
                        target="_blank"
                        :href="urlDownload"
                    >
                        <fa-icon :icon="['far', 'arrow-to-bottom']" />
                    </a>
                    <a class="modal-card-head__icon" @click="handleCloseModal('icon')">
                        <fa-icon :icon="['far', 'times']" />
                    </a>
                </header>
                <section class="modal-card-body">
                    <slot>No modal content provided.</slot>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: { type: String, default: '' },
        urlDownload: { type: String, default: '' },
    },

    emits: ['closed', 'opened'],

    data() {
        return {
            active: false,
            closeTimeout: null,
            hoverIcon: false,
        };
    },

    computed: {
        hasDownload() {
            return Boolean(this.urlDownload.length);
        },

        classes() {
            return [this.size];
        },
    },

    methods: {
        handleCloseModal(type) {
            if (type === 'background') {
                return false;
            }

            this.active = false;

            setTimeout(() => {
                this.$emit('closed', type);
            }, 201);
        },
    },

    mounted() {
        setTimeout(() => {
            this.active = true;
            this.$emit('opened');
        }, 10);
    },
};
</script>
